import { render, staticRenderFns } from "./TenantUsage.vue?vue&type=template&id=3327feff&scoped=true&"
import script from "./TenantUsage.vue?vue&type=script&lang=js&"
export * from "./TenantUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3327feff",
  null
  
)

export default component.exports